<div class="modal-header d-print-none">

  <h4> {{heading | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
    
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="expenseHeadForm" class="form-horizontal" role="form" id="AddVendor">
    <div>
      <div class="row">
        <div class="col-md-6" #parent1>
          <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && expenseHeadForm.get('name').invalid) }">
            <label class="text-muted" style="margin-bottom: 3px;" for="small-square-input"> {{'Name'|translate}}</label>
            <indic-input [parentEl]="parent1" type="text" tabindex="-1" id="vendorName" formControlName="name" required>
              <show-errors *ngIf="submitted" [control]="expenseHeadForm.get('name')" [field]="'Name'"></show-errors>
              <!-- <small class="text-danger" *ngIf="submitted && expenseHeadForm.get('name').hasError('required')">
                {{'Name'|translate}} required
              </small> -->
            </indic-input>
          </div>
        </div>
        <div [ngClass]="{'col-md-6': !userData.isStockInventory, 'col-md-3': userData.isStockInventory}">
          <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && expenseHeadForm.get('unitId').invalid) }">
            <label class="text-muted" for="small-square-input"> {{'Unit'|translate}} {{'Name'|translate}}</label>
            <select class="form-control  form-control-sm" formControlName="unitId" id="select-input">
              <!-- <option value='-1'>Choose {{'Unit'|translate}}</option> -->
              <option *ngFor="let unitObject of allUnitList,let i = index" value={{unitObject.id}}>
                {{unitObject.name}}
              </option>
            </select>
            <!-- <small class="text-danger" *ngIf="submitted && expenseHeadForm.get('unitId').hasError('required')">
            {{'Unit'|translate}} required
          </small> -->
            <!-- <show-errors *ngIf="submitted" [control]="expenseHeadForm.get('unitId')" [field]="'Unit Name'"></show-errors> -->
          </div>
        </div>
        <div class="col-md-3" *ngIf="!!userData.isStockInventory">
          <div class="mb-3 " [ngClass]="{ 'has-danger' : (submitted && expenseHeadForm.get('storeId').invalid) }">
            <label class="text-muted" for="select-input">{{'Default'|translate}} {{'Store'|translate}}</label>
            <select class="form-control form-control-sm" formControlName="storeId">
              <option value="-1">{{'No Store'|translate}}</option>
              <option value="{{store.id}}" *ngFor="let store of allStoreList">{{store.name}}</option>
            </select>
            <!-- <show-errors *ngIf="submitted" [control]="expenseHeadForm.get('storeId')" [field]="'Default Store'"></show-errors> -->
          </div>
        </div>
        
        <div class="col-md-6" *ngIf="!!userData.isStockInventory">
          <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && expenseHeadForm.get('category').invalid) }">
            <label class="text-muted" for="small-square-input"> {{'Category'|translate}} </label>
            <app-multi-select (selected)="onSelect($event)" [options]="allMaterialCategory" inputCssClass="form-control form-control-sm" tabindex="2"
              formControlName="category" placeholder="Category">
              <ng-template addMore>
                <div class="auto_suggest_footer" (click)="addCategoryModalOpen(addMaterialCategory)" tabindex="0">
                  <a>
                    <i class="fa fa-plus-circle" style="font-size:20px;"
                      aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Add Category
                  </a>
                </div>
              </ng-template>
            </app-multi-select>
            <!-- <show-errors *ngIf="submitted" [control]="expenseHeadForm.get('category')" [field]="'Category'"></show-errors> -->
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3"
            [ngClass]="{ 'has-danger' : (submitted && expenseHeadForm.get('accountHeadId').invalid) }">
            <label class="text-muted" for="small-square-input"> {{'Expense'|translate}} {{'Account'|translate}}
              {{'Head'|translate}}</label>
            <select class="form-control  form-control-sm" formControlName="accountHeadId" id="select-input">
              <!-- <option value=''>Choose AccountHead</option> -->
              <option *ngFor="let account of allExpenseAccountsList,let i = index" value={{account.id}}>
                {{account.name}}
              </option>
            </select>
            <!-- <small class="text-danger" *ngIf="submitted && expenseHeadForm.get('accountHeadId').hasError('required')">
              {{'Account'|translate}} {{'Head'|translate}} required
            </small> -->
            <!-- <show-errors *ngIf="submitted" [control]="expenseHeadForm.get('accountHeadId')" [field]="'Account Head'"></show-errors> -->
          </div>
        </div>

        <div class="col-md-12" #parent2>
          <div class="mb-3">
            <label class="text-muted" for="small-square-input">{{'Description'|translate}}</label>
            <indic-input [parentEl]="parent2" [inputOptions]="{keyboardEnable:true,inputarea: 'textarea'}" type="text"
              id="Address" value="37" formControlName="description"></indic-input>
          </div>
        </div>


        <div class="col-md-4" *ngIf="selectedItems?.length > 0">
          <div class="mb-3"
            [ngClass]="{ 'has-danger' : (submitted && expenseHeadForm.get('incomeAccountHeadId').invalid) }">
            <label class="text-muted" for="small-square-input"> {{'Income'|translate}} {{'Account'|translate}}
              {{'Head'|translate}}</label>
            <select class="form-control  form-control-sm" formControlName="incomeAccountHeadId" id="select-input">
              <option *ngFor="let account of allIncomeAccountsList,let i = index" value={{account.id}}>
                {{account.name}}
              </option>
            </select>
            <!-- <small class="text-danger" *ngIf="submitted && expenseHeadForm.get('accountHeadId').hasError('required')">
              {{'Account'|translate}} {{'Head'|translate}} required
            </small> -->
            <!-- <show-errors *ngIf="submitted" [control]="expenseHeadForm.get('accountHeadId')" [field]="'Account Head'"></show-errors> -->
          </div>
        </div>
        <div class="col-md-2" *ngIf="selectedItems?.length > 0">
          <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && expenseHeadForm.get('rate').invalid) }">
            <label class="text-muted" for="small-square-input"> {{'Saleable'|translate}} {{'Rate'|translate}}</label>
            <input class="form-control form-control-sm" type="floatNumber" formControlName="rate">
            <!-- <small class="text-danger" *ngIf="submitted && expenseHeadForm.get('amount').hasError('required')">
              {{'Saleable'|translate}} rate required
            </small> -->
            <!-- <show-errors *ngIf="submitted" [control]="expenseHeadForm.get('rate')" [field]="'Saleable Rate'"></show-errors> -->
          </div>
          <div class="form-check d-flex" style="margin-bottom: 0px;" (click)="isCostChanging($event)">
            <input class="form-check-input float-end" formControlName="isCostChanging" type="checkbox"
               [checked]="expenseHeadForm.get('isCostChanging').value===true" (click)="$event.stopPropagation()">
            <label class="form-check-label ps-2" >{{'Cost Change'|translate}} </label>
          </div>
        </div>
        <div class="col-md-3" *ngIf="!!userData.isStockInventory">
          <!-- <label class="text-muted" for="small-square-input"> &nbsp; </label> -->
          <div class="form-check pt-3 d-flex" (click)="isStockUpdate($event)">
            <input class="form-check-input float-end" formControlName="isStockUpdate" type="checkbox"
               [checked]="expenseHeadForm.get('isStockUpdate').value===true" (click)="$event.stopPropagation()">
            <label class="form-check-label ps-2" >{{'Stock Update' |translate}} </label>
          </div>
          <div *ngIf="expenseHeadForm.get('isStockUpdate').value" class="form-check d-flex" (click)="showStockOption($event)">
            <input class="form-check-input float-end" formControlName="showStockOption" type="checkbox"
               [checked]="expenseHeadForm.get('showStockOption').value===true" (click)="$event.stopPropagation()">
            <label class="form-check-label ps-2" >{{'Show Stock Option' |translate}} </label>
          </div>
        </div>
        <div class="col-md-3" *ngIf="expenseHeadForm.get('isStockUpdate').value">
          <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && expenseHeadForm.get('outOfStockLimit').invalid) }">
            <label class="text-muted"> {{'Out of stock Limit'|translate}}</label>
            <input class="form-control form-control-sm" type="floatNumber" formControlName="outOfStockLimit">
            <!-- <small class="text-danger" *ngIf="submitted && expenseHeadForm.get('amount').hasError('required')">
              {{'Saleable'|translate}} rate required
            </small> -->
            <!-- <show-errors *ngIf="submitted" [control]="expenseHeadForm.get('rate')" [field]="'Saleable Rate'"></show-errors> -->
          </div>
        </div>
        <!-- <div class="col-md-3" *ngIf="selectedItems?.length > 0">
          <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && expenseHeadForm.get('samarpanaFee').invalid) }">
            <label class="text-muted" for="small-square-input"> {{'Samarpana'|translate}} {{'Fee'|translate}}</label>
            <input class="form-control form-control-sm" type="floatNumber" id="rate" formControlName="samarpanaFee">            
          </div>
        </div> -->

        <!-- <div class="col-md-6" >
          <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && expenseHeadForm.get('quantity').invalid) }">
            <label class="text-muted" for="small-square-input"> {{'Opening'|translate}} {{'Quantity'|translate}}</label>
            <input class="form-control form-control-sm" type="floatNumber" id="quantity" formControlName="quantity" *ngIf="buttonName=='update'" disabled="disabled">
            <input class="form-control form-control-sm" type="floatNumber" id="quantity" formControlName="quantity" *ngIf="buttonName!='update'">
          </div>
        </div> -->
        
      </div>
    </div>

  </form>
</div>
<div class="modal-footer d-print-none">
  <button class="btn btn-secondary btn-sm" type="button" (click)="activeModal.dismiss()">cancel</button>
  <button class="btn btn-success btn-sm" type="button" (click)="add()">{{buttonName}}</button>
</div>


<ng-template #addMaterialCategory let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4> Add Category </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.dismiss()">
      
    </button>
  </div>
  <div class="modal-body">
    <form autocomplete="off" class="row">
      <div class="col-sm-12">
        <div class="mb-3 " [ngClass]="{'has-danger':(submitting && !materialCategory)}">
          <label class="text-muted" for="large-rounded-input">Category</label>
          <input class="form-control form-control-sm" type="text" [ngModelOptions]="{standalone: true}"
            [(ngModel)]="materialCategory">
          <small class="text-danger" *ngIf="submitting && !materialCategory">
            Category {{'is required'|translate}}
          </small>



        </div>
      </div>

      <hr class="padding-bottom-1x">
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm" type="button" (click)="modalRef.dismiss()">cancel</button>
    <button class="btn btn-success btn-sm" type="button" (click)="submitMaterialCategory()">Submit</button>
  </div>
</ng-template>